import { ParsedUrlQuery } from 'node:querystring';

const PLATFORMS = ['bento', 'gousto'] as const;
type Platform = (typeof PLATFORMS)[number];

function isPlatform(value: unknown): value is Platform {
  return PLATFORMS.includes(value as Platform);
}

export function headersWithXGoustoPlatform(query: ParsedUrlQuery): {
  'x-gousto-platform'?: Platform;
} {
  return isPlatform(query.platform) ? { 'x-gousto-platform': query.platform } : {};
}
